import { apiSlice } from '../../../app/api/apiSlice';
import Config from '../../../configs/appConfig';
import makeQueryParams from '../../../lib/makeQueryParams';



export const PushNotificationsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => {
    return ({
      getPushNotifications: builder.query({
        query: (params) => {
          const queryParams = makeQueryParams(params.queryParams);

          return ({ url: `/${Config.VITE_HC_API_VERSION}/push-notifications${queryParams}${params?.includes || ''}` });
        },
        transformResponse: (response) => {
          return {
            data: response?.data,
            pagination: response?.meta?.pagination,
          };
        },
        transformErrorResponse: (response) => response?.data?.errors,
        providesTags: [ 'PushNotifications' ],
        keepUnusedDataFor: 1,
      }),
      getSpecificPushNotification: builder.query({
        query: ({ notificationId, includes }) => ({ url: `/${Config.VITE_HC_API_VERSION}/push-notifications/${notificationId}${includes}` }),
        transformResponse: (response) => response.data,
        providesTags: [ 'PushNotificationItem' ],
      }),
      createPushNotification: builder.mutation({
        query: (values) => ({
          url: `/${Config.VITE_HC_API_VERSION}/push-notifications`,
          method: 'POST',
          body: values,
        }),
        invalidatesTags: () => [ 'PushNotifications', 'Template' ],
      }),
      updatePushNotification: builder.mutation({
        query: ({ id, values }) => ({
          url: `/${Config.VITE_HC_API_VERSION}/push-notifications/${id}`,
          method: 'POST',
          body: values,
        }),
        invalidatesTags: () => [ 'PushNotifications', 'Template', 'PushNotificationItem' ],
      }),
      deletePushNotification: builder.mutation({
        query: (id) => ({
          url: `/${Config.VITE_HC_API_VERSION}/push-notifications/${id}`,
          method: 'DELETE',
        }),
        invalidatesTags: () => [ 'PushNotifications', 'Template' ],
      }),
      clonePushNotification: builder.mutation({
        query: (id) => ({
          url: `/${Config.VITE_HC_API_VERSION}/push-notifications/${id}/clone`,
          method: 'POST',
        }),
        invalidatesTags: () => [ 'PushNotifications', 'Template' ],
      }),
      sendTestPushNotification: builder.mutation({
        query: (values) => ({
          url: `/${Config.VITE_HC_API_VERSION}/push-notifications/test-push`,
          method: 'POST',
          body: values.formData,
        }),
      }),
    });
  },
});

export const {
  useGetPushNotificationsQuery,
  useGetSpecificPushNotificationQuery,
  useCreatePushNotificationMutation,
  useUpdatePushNotificationMutation,
  useDeletePushNotificationMutation,
  useClonePushNotificationMutation,
  useSendTestPushNotificationMutation,
} = PushNotificationsApiSlice;
